import { combineEpics } from 'redux-observable';

import { Epics as AnalyticsEpics } from 'modules/analytics-provider';
import { Epics as LoginEpics } from '../modules/login';
import { Epics as LoadingManagerEpics } from '../modules/loading-manager';
import { Epics as ChangeViewEpics } from 'modules/change-view';
import { Epics as RouteEpics } from 'modules/router';

const analyticsAsyncEpics = AnalyticsEpics.createEmptyAnalyticsEpics();
const routerAsyncEpics = RouteEpics.createEmptyRouterEpics();

AnalyticsEpics.initAnalyticsObservable$.subscribe(isAnalyticsEnabled => {
    if (isAnalyticsEnabled) {
        AnalyticsEpics.loadAnalyticsEpicsAsync(import('../modules/analytics/analytics.epic'));
    }
});

export const rootEpic = combineEpics(
    LoginEpics.default,
    ChangeViewEpics.default,
    LoadingManagerEpics.default,
    analyticsAsyncEpics,
    routerAsyncEpics
);

export default rootEpic;
